export default __webpack_public_path__ + "SLFS-methodology.pdf";